import { MenuProps } from 'antd';
import { TFunction } from 'i18next';

const MENU_KEYS = {
  SAVE: 'save-draft',
  DISCARD: 'discard-draft',
} as const;

export const getMenuItems = (t: TFunction): MenuProps['items'] => [
  { key: MENU_KEYS.SAVE, label: t('Exit & Save Draft') },
  { key: MENU_KEYS.DISCARD, label: t('Exit & Discard') },
];
